var version = {
    "name":      "dativery",
    "buildDateCode": "20251204-190403",
    "buildDate": "Thu Dec 04 2025 19:04:03 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251204-190403",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;